import i18n from 'i18next';
// Force reload
import { initReactI18next } from 'react-i18next';

import en from './i18n/en.json';
import fr from './i18n/fr.json';
import pt from './i18n/pt.json';
const savedLang = sessionStorage.getItem('lang') || localStorage.getItem('lang') || navigator.language;

function normalize(lang: string): string {
  const l = lang.toLowerCase();
  if (l.startsWith('pt')) return 'pt_BR';
  if (l.startsWith('en')) return 'en_US';
  if (l.startsWith('fr')) return 'fr_FR';
  return 'pt_BR';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en_US: { translation: en },
      fr_FR: { translation: fr },
      pt_BR: { translation: pt },
    },
    lng: normalize(savedLang || 'pt-BR'),
    fallbackLng: 'pt_BR',
    interpolation: { escapeValue: false },
    defaultNS: 'translation',
    ns: ['translation'],
  });

console.log('Current Language (i18n):', i18n.language);
console.log('Loaded Resources (pt_BR):', i18n.getResourceBundle('pt_BR', 'translation'));
console.log('Loaded Resources (pt-BR):', i18n.getResourceBundle('pt-BR', 'translation'));


// Helper to map i18n language codes to Intl locales
export function getLocale(): string {
  const lang = i18n.language || 'pt_BR';
  if (lang.startsWith('pt')) return 'pt-BR';
  if (lang.startsWith('en')) return 'en-US';
  if (lang.startsWith('fr')) return 'fr-FR';
  return 'pt-BR';
}

// Global translate helper
export function t(key: string, options?: any): string {
  // i18next types can return objects when returnObjects=true; our app uses flat string keys.
  // Cast to string to satisfy TS while keeping runtime behavior correct.
  return i18n.t(key, options as any) as string;
}

export default i18n;
